// The CV lives in Google Docs — one source of truth. Everything below stays
// current automatically: /preview is embedded on the about page and
// /export?format=pdf backs the nav's download button.
const RESUME_DOC_ID = "1X8PGRdX4TALqtZWYyWvlamY43V8aMg-ASKDls_CNJJw";

export const RESUME_DOC = {
  docId: RESUME_DOC_ID,
  previewUrl: `https://docs.google.com/document/d/${RESUME_DOC_ID}/preview`,
  pdfUrl: `https://docs.google.com/document/d/${RESUME_DOC_ID}/export?format=pdf`,
  shareUrl: `https://docs.google.com/document/d/${RESUME_DOC_ID}/edit?usp=sharing`
};

export default {
  personalInfo: {
    name: "George Kobina Koomson",
    title: "Software Engineer",
  },
  professionalSummary:
    "10+ years building payment and SaaS platforms for companies including Taxfix, Vodafone and OA Pay. Delivered several platforms including micro-frontend and event-driven payment systems affecting hundreds of thousands of transactions, and rebuilt Vodafone Ghana's onboarding flow, cutting onboarding time from two weeks to under 15 minutes. Expert in delivering seamless yet robust, modern and accessible frontend experiences, building high-performance backends (in Node.js, Python, Go), streamlining deployment pipelines, setting up observability and monitoring, and bridging the gap between complex engineering systems and product strategy.",
  skills: {
    programmingLanguages: {
      proficient: [
        "TypeScript",
        "JavaScript",
        "Python",
        "PHP",
        "HTML",
        "XML",
        "CSS",
        "SCSS",
      ],
      familiar: ["Java", "C++", "Rust"],
    },
    platformsFrameworks: [
      "React JS",
      "React Native",
      "Next Js",
      "Vue JS",
      "NuxtJs",
      "Node Js",
      "Express",
      "Django",
      "Android",
      "iOS",
      "Bootstrap",
      "Tailwind",
    ],
    uiUxDesign: ["Figma", "Adobe XD", "Marvel app"],
    databaseOrm: [
      "MySQL",
      "Postgresql",
      "Mongodb",
      "Sequelize",
      "Mongoose",
      "Peewee",
      "Red Bean",
    ],
    graphicDesign: [
      "Adobe Photoshop",
      "Illustrator",
      "InDesign",
      "Corel Draw Graphic Suite",
    ],
    versionControl: ["Git", "Github", "Bitbucket"],
    multimedia: ["Adobe Audition", "Premiere Pro", "Trimble Sketchup"],
    devOps: ["AWS", "Heroku", "Docker", "Travis CI", "GCP"],
  },

  experience: [
    {
      company: "Taxfix",
      location: "Remote, Accra",
      position: "Senior Software Engineer (Contract)",
      period: "Feb 2025 - July 2025",
      description:
        "I’ve worked with Taxfix, a client for Upbeat SL. on a large codebase, building features for the front-end with micro-front-end architecture and event driven backend of the payment and subscriptions part of the platform, setup as mono repos, writing all kinds of automated tests, while ensuring strict adherence to the rigorous engineering standards, running AB testing experiments in order to satisfy the hundreds of thousands of our customers.",
    },
    {
      company: "Upbeat SL.",
      location: "Remote, Accra",
      position: "Senior Software Engineer (Contract)",
      period: "Sep 2024 - Date",
      description:
        "At Upbeat, a software development agency, I’ve worked on a number of projects in a relatively short amount of time for a number of clients, including a shipment management product, a SAAS product that enables real estate companies advertise and sell their properties, a mobile app for mother care, a website for a fitness company and upgrading the company’s website.",
    },
    {
      company: "Obsidian Achernar Technologies co. ltd.",
      location: "Accra, Ghana",
      position: "Engineering Manager",
      period: "January 2023 - Date",
      description:
        "As frontend engineering manager, my major role is to oversee and manage the design and development of all frontend applications. Working closely with my team, the UI/UX team and the backend engineers to design customer facing applications and internal tools. Strategising, Designing, building and testing UI components for our internal components library for easy scaffolding of requested features in the applications we work on. Conducting peer code review. Leading research and development for experimental solutions to niche problems. Mentoring and assisting junior developers. Planning and setting KPIs for the frontend team and the members of the team. Conducting periodic performance appraisal. Liaising between top management, managers of other departments and the engineers.",
    },
    {
      company: "Obsidian Achernar Technologies co. ltd.",
      location: "Accra, Ghana",
      position: "Senior Software Engineer",
      period: "Feb 2021 - Jan 2023",
      description:
        "As lead frontend engineer, my major role is to oversee the design and development of applications that digitise and enhance remittance, forex brokerage and securities trading, and handling sections of developer recruitment. Working closely with backend engineers to design REST APIs with performance in mind. Designing, building and testing UI components to meet user stories. Conducting peer code review. Leading research and development for experimental solutions to niche problems. Mentoring and assisting junior developers. Planning and setting KPIs for the frontend team and the members of the team.",
    },
    {
      company: "Vodafone Ghana ltd.",
      location: "Accra, Ghana",
      position: "Software Engineer",
      period: "Feb 2020 - March 2021",
      highlight:
        "As frontend engineer, my team and I reduced the onboarding time for new and returning fibre broadband customers from 2 weeks to on averagely less than 15 minutes and as well undertook rewriting and redesigning of the user experience of Vodafone's chatbot platform to both enhance maintenance and ease of use as well as visual appeal.",
      description:
        "Building web applications to enable customer on-demand self service for millions of our customers as well enabling customer-service efficiently address customer concerns and onboard new customers as well. Building in-house web applications that enable efficient feedback collection and office seating reservations due to social distancing protocols. Working closely with backend engineers to design REST APIs. Designing, building and testing UI components to meet user stories. Sprint planning and converting user stories into sprint activities. Documenting frontend component APIs using Confluence. Conducting peer code review.",
    },
    {
      company: "F Project Agency",
      location: "Accra, Ghana",
      position: "Lead Software Engineer, Designer",
      period: "Jul 2019 - Feb 2020",
      description:
        "In my capacity as tech and design lead, I oversaw the setting of overall engineering goals and planning of activities involved in making the company's in-house applications and client facing applications. Developing the company's strategy for using technological resources. Using stakeholders' feedback to inform necessary improvements and adjustments to technology. System design and implementation and UI/UX and Graphic Design. Communicate technology strategy to top management. Delivery of graphic resources, client decks and UI designs.",
    },
    {
      company: "Sharehouse ltd. (Shina Labs)",
      location: "Nairobi, Kenya",
      position: "C.T.O (Co-founder)",
      period: "Aug 2018 - May 2019",
      description:
        "System design and implementation. Overseeing the overall engineering goals and activities that make the Sharehouse, warehouse on-demand, platform. Developing the company's strategy for using technological resources. Outlining and ensuring the strict following of the path to incrementally converting the sharehouse MVP to the planned minimum awesome product. Monitor KPIs and IT budgets to assess technological performance. Use stakeholders' feedback to inform necessary improvements and adjustments to technology. Communicate technology strategy to partners and investors.",
    },
    {
      company: "Creative arts council",
      location: "Accra, Ghana",
      position: "Web Developer (Contract)",
      period: "2018",
      description:
        "Converted the designs submitted by the Government of Ghana's creative arts council (CAC) designers into web pages using HTML, CSS and JavaScript. Communicated technology strategy to partners and investors. Use stakeholders' feedback to inform necessary improvements and adjustments to the website.",
    },
    {
      company: "Codbit Ghana ltd.",
      location: "Accra, Ghana",
      position: "Lead web frontend engineer (Contract)",
      period: "Aug 2018 - Dec 2018",
      description:
        'System UI/UX design and implementation. Designing web and mobile UI and UX for a saas food ordering application application. Implemented web UIs that consume REST APIs and enable "tenants" admins manage their space in the system. Liaising with the backend developers to ascertain the need for or availability of APIs that enable user interaction. Communicate technology strategy progress and suggestions to fellow developers and top management. Standardised the mode of communication of available APIs with an API specification document.',
    },
    {
      company: "Sharehouse ltd. (Shina Labs)",
      location: "Accra, Ghana",
      position: "C.P.O, Lead Frontend Engineer (Co-founder)",
      period: "2018",
      description:
        "UI/UX design and implementation. Conduct user research to understand our ideal persona and other persona including their needs. Design customer journeys and user flows that map onto the needs of users discovered. Create UI wireframes and mockups from which actual UI, aimed at creating the best user experience, would be built. Implement applications' UI to mirror what had been designed with code. Implement user interaction by writing extensive and maintainable JavaScript code.",
    },
    {
      company: "Upscale Communications",
      location: "Accra, Ghana",
      position: "Business Development Manager",
      period: "2018",
      description:
        "Management of Technical business Activity. Overseeing the technical aspects of the business to meet the desire of all stakeholders to ensure growth and profitability. Technology management and supplies management.",
    },
    {
      company: "BARGE Studios, Inc.",
      location: "Accra, Ghana",
      position: "Lead frontend Engineer",
      period: "Aug 2015 - Jul 2017",
      description:
        "UI/UX design and implementation. Create UI wireframes and mockups from which actual UI, aimed at creating the best user experience, would be built. Implement applications' UI to mirror what had been designed with code. Implement user interaction by writing extensible and maintainable JavaScript code as part of a team. Manage design of dynamic widgets focused on client data entry. Responsible for creative design for BARGE Abacus, A school management system. Built certain backend features in BARGE Abacus.",
    },
    {
      company: "Upscale Communications",
      location: "Accra, Ghana",
      position: "Senior Graphic Designer",
      period: "May 2012 - Sept 2013",
      description:
        "Graphic designing. Conceptualise and create artworks for flyers, banners, organisational souvenirs among others using modern design tools, techniques and resources. Manage printing of artworks and documents on media including paper, PVC, SAV, ceramic, flexy. Handle maintenance of computers, network and printing Equipment.",
    },
  ],
  education: [
    {
      institution: "Meltwater Entrepreneurial School of Technology",
      location: "Accra, Ghana",
      degree: "Diploma, Software Entrepreneurship",
      period: "2017 - 2018",
      highlights: [
        "Studied Software Development, Business and Communications",
        "Extended work on Bumble bee Js. A lightweight UI framework aimed at reducing the repetitive work associated with creating UI widgets.",
        "Created Bumble bee CSS, a utility-first framework, using OOCSS techniques and SCSS with class names heavily inspired Zen (Emmet) CSS abbreviations.",
        "Designed and implemented the UI for a hospital management system.",
        "Started Js Hack, an Accra based Web Developer community, which regularly organises JavaScript meetups dubbed JS Camp primarily focused on sharing JavaScript Knowledge as well as knowledge of CSS and HTML.",
      ],
    },
    {
      institution: "University of Ghana, Legon",
      location: "Accra, Ghana",
      degree: "BSc. Information Technology",
      period: "2013 - 2017",
      highlights: [
        "Built a web search engine using python.",
        "Begun work on Bumble bee Js. A lightweight UI framework aimed at reducing the repetitive work associated with creating UI widgets.",
        "Built Moov, a parcel tracking system.",
        "Built a VOD service for long journey buses using vanilla PHP.",
        "Built company websites for a number of clients.",
        "Assisted Teaching Assistant in handling Program Design and Data Structures class.",
        "Contributed to building Schools Ghana, an online schools registry aimed at enabling parents make data-driven choices regarding their wards' schooling.",
      ],
    },
    {
      institution: "Accra Academy",
      location: "Accra, Ghana",
      degree: "West African Senior School Certificate (Business)",
      period: "2008 - 2012",
      highlights: [
        "Studied Specialisation courses in Financial Accounting, Management (Cost) Accounting, Economics and Principles of Business Management.",
        "Was part of the team that represented the school in the National Finance Quiz competition for senior high schools organised by the Bank of Ghana.",
        "Was part of the team that re-initiated the annual creation of the Bleoo Empire school magazine.",
        "The team conducted research with the appropriate stakeholders and collected relevant material for the creation of the 2011 Phoenix Edition.",
      ],
      hide: true,
    },
  ],
  certifications: [
    {
      title: "Application Security Analyst Mastery Award",
      issuer: "IBM MEA Initiative",
      year: "2016",
      description:
        "Learned to analyse and detect security flaws in web applications as well as how to avoid them. Learned to use IBM AppScan to perform automated penetration tests on web applications to expose vulnerabilities and produce a report from which the appropriate security advice can be given.",
    },
    {
      title: "Mobile Application Developer Mastery Award",
      issuer: "IBM MEA Initiative",
      year: "2015",
      description:
        "Learned to build hybrid mobile applications using the IBM Mobile First platform making use of mobile-web technologies while taking advantage of the native capabilities available in mobile devices. Acquired critical, large scale mobile application architecture skills.",
    },
  ],
  affiliations: [
    { role: "Lead Organiser", organisation: " Js Camp by Js Hack Accra" },
    { role: "Mentor", organisation: "SeedStars World Accra 2018" },
    { role: "Volunteer Teaching Assistant", organisation: "Python Ghana" },
  ],
  references: [
    {
      name: "Mr Paul Armah Teiko",
      position: "Associate Consultant, Kreston Coopers",
      contact: "+233 246 643 535",
    },
    {
      name: "Samuel Owusu Adjei",
      position: "Marketing Manager, Angel Media",
      contact: "+233 266 110 870",
    },
  ],
};
